import {Type} from '@angular/core';
import {CustomFragmentRegistration, FragmentComponent} from '@nh/angular-tses';
import {HTMLFragmentComponent} from '../html/html-fragment.component';
import {AttachmentFragment, deserialiseAttachmentFragment} from './attachment-fragment';
import {ConditionFragment, deserialiseConditionFragment} from './condition-fragment';
import {DASFragmentType} from './das-fragment-type';
import {DepartureFragment, deserialiseDeparture} from './departure-fragment';
import {DepartureInformationFragment, deserialiseDepartureInformationFragment} from './departure-information-fragment';
import {deserialiseHTMLFragment, HTMLFragment} from './html-fragment';
import {deserialiseLinkedDepartureFragment, LinkedDepartureFragment} from './linked-departure-fragment';
import {deserialiseLocationFragment, LocationFragment} from './location-fragment';

export const DAS_CUSTOM_REGISTRATIONS: CustomFragmentRegistration[] = [
  {
    type: DASFragmentType.DEPARTURE,
    component: void 0,
    fragment: DepartureFragment,
    deserialise: deserialiseDeparture,
  },
  {
    type: DASFragmentType.HTML,
    component: HTMLFragmentComponent,
    fragment: HTMLFragment,
    deserialise: deserialiseHTMLFragment,
  },
  {
    type: DASFragmentType.LOCATION,
    component: void 0,
    fragment: LocationFragment,
    deserialise: deserialiseLocationFragment,
  },
  {
    type: DASFragmentType.ATTACHMENT,
    component: void 0,
    fragment: AttachmentFragment,
    deserialise: deserialiseAttachmentFragment,
  },
  {
    type: DASFragmentType.INFORMATION,
    component: void 0,
    fragment: DepartureInformationFragment,
    deserialise: deserialiseDepartureInformationFragment,
  },
  {
    type: DASFragmentType.CONDITION,
    component: void 0,
    fragment: ConditionFragment,
    deserialise: deserialiseConditionFragment,
  },
  {
    type: DASFragmentType.LINKED_DEPARTURE,
    component: void 0,
    fragment: LinkedDepartureFragment,
    deserialise: deserialiseLinkedDepartureFragment,
  },
];

export const DAS_CUSTOM_COMPONENTS: Type<FragmentComponent>[] = [HTMLFragmentComponent];
